import { render, staticRenderFns } from "./EventLocation.vue?vue&type=template&id=b30f0506&scoped=true&"
import script from "./EventLocation.vue?vue&type=script&lang=js&"
export * from "./EventLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b30f0506",
  null
  
)

export default component.exports